module.exports = __webpack_public_path__ + "static/media/ic_clock.caf43a7e.svg";